/* KerWell — Carte produit 08 : ajout au panier AJAX + Quick Cart Ella */

(function () {
  if (window.KerwellCollectionCard08Bound) return;
  window.KerwellCollectionCard08Bound = true;

  document.addEventListener('click', async function (event) {
    const button = event.target.closest('[data-kwc-add]');

    if (!button || button.disabled) return;

    event.preventDefault();

    const card = button.closest('[data-kwc-card]');
    const notice = card && card.querySelector('[data-kwc-notice]');

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    if (notice) notice.textContent = '';

    const base =
      (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    try {
      // Ajouter le produit au panier
      const response = await fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: Number(button.dataset.variantId),
          quantity: 1
        })
      });

      const item = await response.json();

      if (!response.ok) {
        throw new Error(
          item.description || item.message || 'Ajout au panier impossible.'
        );
      }

      // Récupérer le panier actualisé
      const cartResponse = await fetch(base + 'cart.js', {
        headers: {
          'Accept': 'application/json'
        }
      });

      if (!cartResponse.ok) {
        throw new Error('Le panier n’a pas pu être actualisé.');
      }

      const cart = await cartResponse.json();

      // Actualiser et ouvrir le Quick Cart latéral Ella
      const halo = window.halo;

      if (halo && typeof halo.updateSidebarCart === 'function') {
        if (typeof halo.initSidebarCart === 'function') {
          halo.initSidebarCart();
        }

        halo.updateSidebarCart(cart);

        if (typeof halo.updateCart === 'function') {
          halo.updateCart(cart);
        }

        document.body.classList.add('cart-sidebar-show');
      } else {
        const opener = document.querySelector(
          '[data-cart-sidebar], [data-cart-open], ' +
          '.header__icon--cart, .header-cart .cart-icon'
        );

        if (opener) {
          opener.click();
        } else if (notice) {
          notice.textContent = 'Produit ajouté au panier.';
        }
      }
    } catch (error) {
      if (notice) {
        notice.classList.remove('visually-hidden');
        notice.textContent =
          error.message || 'Erreur lors de l’ajout au panier.';
      }

      console.error('[KerWell collection card 08]', error);
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
})();